














































































import {Component, Prop} from 'vue-property-decorator';
import abpbase from "@/lib/abpbase";
import PrimaryPage from "@/layouts/primaryPage.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import KBList from "@/views/knowledgeBase/list.vue";

@Component({
    name: 'index',
    components: {KBList, PrimaryPage}
})
export default class index extends abpbase {
    @Prop({type: String, default: ''}) queryParams: string;
    //所有的menu
    allMenus: any[] = [];

    keywords: string = '';
    docTypeId: string = '';

    selectedKeys: string[] | number[] = [0];

    defRoutes = [{
        path: 'knowledgeBase',
        breadcrumbName: '知识库',
    }];

    //获取所有树节点数据
    fetchMenus() {
        ajaxHelperInstance.get('web/docType/findAll', {}, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                this.allMenus = [{
                    typeId: null,
                    value: 0,
                    parentId: null,
                    typeName: "全部分类",
                    label: "全部分类",
                    description: null,
                    remark: null,
                    createDate: null,
                    updateDate: null,
                    deleted: 0,
                    children: data.data || []
                }];
                console.log(this.allMenus);
            }
        });
    }

    //选择menu
    handelSelectedMenu(e) {
        let {key} = e;
        this.selectedKeys = [key];
        this.docTypeId = key === 0 ? undefined : key;
        this.showList();
    }

    //关键字搜索
    handleSearch(keywords: string = '') {
        this.keywords = keywords;
        this.showList();
    }

    //显示列表页
    showList() {
        // let queryParams = JSON.stringify({keywords: this.keywords, docTypeId: this.docTypeId});
        // this.switchRouting('knowledgeBaseList', {
        //     queryParams: queryParams
        // });

        this.$nextTick(() => {
            let kbList: any = this.$refs.kbList;
            kbList.show(this.docTypeId, this.keywords);
        });
    }

    mounted() {
        this.$nextTick(() => {
            this.fetchMenus();
        });

        try {
            let obj = JSON.parse(this.queryParams);
            if (obj) {
                this.docTypeId = obj.docTypeId;
                this.keywords = obj.keywords;
            }
        } catch (e) {

        }
        this.showList();
    }
}
